import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'outletFilter'
})
export class OutletFilterPipe implements PipeTransform {
  transform(
    items: any,
    regionSearch: any,
    subRegionSearch: any,
    clusterSearch: any,
    citySearch: any
  ) {
    regionSearch = this.getObject(regionSearch, 'RegionName');
    subRegionSearch = this.getObject(subRegionSearch, 'SubRegionName');
    clusterSearch = this.getObject(clusterSearch, 'ClusterName');
    citySearch = this.getObject(citySearch, 'CityName');
    if (!regionSearch) {
      regionSearch = [];
    }
    if (!subRegionSearch) {
      subRegionSearch = [];
    }
    if (!clusterSearch) {
      clusterSearch = [];
    }
    if (!citySearch) {
      citySearch = [];
    }
    if (items && items.length) {
      return items.filter(item => {
        if (
          (regionSearch && regionSearch.length > 0 && regionSearch.indexOf(item.RegionName) < 0) ||
          (subRegionSearch && subRegionSearch.length > 0 && subRegionSearch.indexOf(item.SubRegionName) < 0) ||
          (clusterSearch && clusterSearch.length > 0 && clusterSearch.indexOf(item.ClusterName) < 0) ||
          (citySearch && citySearch.length > 0 && citySearch.indexOf(item.CityName) < 0)
        ) {
          return false;
        }
        return true;
      });
    } else {
      return items;
    }
  }

  getObject(data, type){
    let _output: any = [];
    for (var i=0; i<data?.length; i++) {
      if(type === 'RegionName'){
        _output.push(data[i]['RegionName']);
      }
      if(type === 'SubRegionName'){
        _output.push(data[i]['SubRegionName']);
      }
      if(type === 'ClusterName'){
        _output.push(data[i]['ClusterName']);
      }
      if(type === 'CityName'){
        _output.push(data[i]['CityName']);
      }
      if(type === 'OutletCode'){
        _output.push(data[i]['OutletCode']);
      }
    }
    return _output;
  }
}
